/** @format */

import {roundFloatNumber, safeDivide} from 'helpers/numberHelpers';

import {GraphStat} from '../../models/common';
import {MediaplanStatFromQuery} from '../../models/api';
import {PartialGraphStatList} from './types';

const collectMediaplanStats = (
  mediaplanStats: ReadonlyArray<MediaplanStatFromQuery>,
): PartialGraphStatList => {
  const result: PartialGraphStatList = {};

  mediaplanStats.forEach(graph => {
    const {
      spent,
      impressions,
      reach,
      avgVideoCompleteCost,
      videoCompleteRate,
      videoComplete,
      bounces,
      comments,
      likes,
      revenue,
      shares,
      conversions,
      sessions,
      collectedOn,
    } = graph;

    const engagement = (likes ?? 0) + (comments ?? 0) + (shares ?? 0);
    const quotient = safeDivide(engagement, reach);

    const newData: Partial<GraphStat> = {
      date: collectedOn,
      declines: roundFloatNumber(safeDivide(bounces, sessions) * 100, 1),
      income: revenue ?? 0,
      cpl: roundFloatNumber(safeDivide(spent, conversions), 1),
      drr: roundFloatNumber(safeDivide(spent, revenue) * 100, 1),
      romi: roundFloatNumber(safeDivide(revenue, spent) * 100, 1),
      cpm: roundFloatNumber(safeDivide(spent, impressions) * 1000, 1),
      avgVideoCompleteCost: avgVideoCompleteCost ?? 0,
      reach: reach ?? 0,
      vtr: videoCompleteRate ?? 0,
      conversions: conversions ?? 0,
      videoComplete: videoComplete ?? 0,
      engagement,
      er: roundFloatNumber(quotient * 100, 1),
      bounces: bounces ?? 0,
      sessions: sessions ?? 0,
    };

    if (result[collectedOn]) {
      result[collectedOn] = {
        ...result[collectedOn],
        ...newData,
      };
    } else {
      result[collectedOn] = newData;
    }
  });

  return result;
};

export {collectMediaplanStats};
